import Create from './create/CreateMerchDistributionSectionTemplate';
import Edit from './edit/EditMerchDistributionSectionTemplate';
import Individual from './individual/MerchDistributionTemplateSection';

export default { Create, Individual, Edit };
